import React from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '../state'

const MoveDeleteCanvasAct = props => {
  let [currentState] = useStateValue()
  return (
    <div className="text-right">
      Canvas Group:
      <select
        value={props.canvasGroupId}
        className="ml-3"
        onChange={props.handleCanvasGroupSelect}
      >
        {currentState.groups.map((group, index) => {
          return (
            <option value={group.id} key={index}>
              {group.name}
            </option>
          )
        })}
      </select>
      <button
        className="btn btn-myed btn-danger-myed btn-danger btn-sm-myed ml-5 mt-2"
        onClick={props.openCloseModal}
      >
        Delete From Canvas
      </button>
    </div>
  )
}

export default MoveDeleteCanvasAct

MoveDeleteCanvasAct.propTypes = {
  canvasGroupId: PropTypes.number,
  handleCanvasGroupSelect: PropTypes.func,
  openCloseModal: PropTypes.func,
}
